import actionTypes from '../actions'
import { v4 as uuidv4 } from 'uuid'

const initialState = {
  vaultSummary: {
    vault_verified: true,
  },
  loadingVaultSummary: true,
  uploadingStatus: 1, // Draft document files uploading status, 1: Not started, 2: In progress, 3: Done, 4: Failed
  readyToUpload: false, // Check if the uploading form is ready to be uploaded/submitted
  accessCodeVerified: false, // Check if the verification is done
  attempts: 0, // Verify attempts
  draftDocuments: [], // Draft document files.
  draftBOs: [], // Draft BO infos.
  documents: [], // Actual documents from the backend
  BOs: [], // Actual BOs from the backend
  loadingDocuments: false,
  loadingBOs: false,
  isVerifying: false,
  submittingDraftDocuments: false,
  submittingDraftBOs: false,
  //TODO: For pagination. Currently fetching all documents and beneficial owners
  totalDocuments: 0,
  documentPageNo: 1,
  documentPageSize: 20,
  totalBOs: 0,
  boPageNo: 1,
  boPageSize: 20,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'userSignOut': {
      return { ...initialState }
    }
    case actionTypes.VAULTFETCHINGSUMMARY:
      return { ...state, loadingVaultSummary: true }
    case actionTypes.VAULTFETCHINGSUMMARYDONE:
      return { ...state, loadingVaultSummary: false, vaultSummary: action.payload }
    /*NOTE: Verification actions */
    case actionTypes.VAULTOPTVERIFYSTARTED:
      return { ...state, isVerifying: true }

    case actionTypes.VAULTOTPVERIFYDONE:
      return { ...state, isVerifying: false, accessCodeVerified: true, attempts: 0 }

    case actionTypes.VAULTOTPVERIFYFAILED:
      return { ...state, isVerifying: false, accessCodeVerified: false, attempts: state.attempts + 1 }

    case actionTypes.VAULTVERITYRESET:
      return { ...state, accessCodeVerified: false }

    /*NOTE: Document actions */
    case actionTypes.VAULTUPDATEUPLOADINGSTATUS: {
      return {
        ...state,
        uploadingStatus: action.payload.status,
      }
    }

    case actionTypes.VAULTCLEARSTAUS: {
      return {
        ...state,
        vaultSummary: { vault_verified: true },
      }
    }

    case actionTypes.VAULTSUBMITTINGDRAFTDOCUMENTS:
      return {
        ...state,
        submittingDraftDocuments: true,
      }
    case actionTypes.VAULTSUBMITTINGDRAFTDOCUMENTSDONE:
      return {
        ...state,
        submittingDraftDocuments: false,
      }

    case actionTypes.VAULTDRAFTDOCUMENTSSADDED: {
      //TODO: This draft document file metadata is not matched with backend model
      //      While uploading the document, we need to fit the backend model
      const newDraftFiles = action.payload.draftDocuments.map(artifact => ({
        //NOTE: uuid will be updated once artifact has been saved
        //      uuid just temporary use once files are added
        id: uuidv4(),
        path: artifact.path,
        fileName: artifact.name,
        fileType: artifact.type,
        documentType: null,
        description: null,
        effectiveDate: null,
        dateUploaded: new Date().toString(),
        size: artifact.size,
        uploadingProgress: 0,
        // extension: artifact.extension,
        status: 'pending',
        rawFile: artifact,
        uploadingError: null,
      }))

      return {
        ...state,
        draftDocuments: [...state.draftDocuments, ...newDraftFiles],
        readyToUpload: newDraftFiles.every(
          artifact => artifact.documentType && artifact.description && artifact.effectiveDate,
        ),
      }
    }

    case actionTypes.VAULTUPDATEDRAFTDOCUMENT: {
      const { id, ...rest } = action.payload
      const newDraftFiles = state.draftDocuments

      const index = newDraftFiles.findIndex(e => e.id === id)
      if (index !== -1) {
        newDraftFiles[index] = { ...newDraftFiles[index], ...rest }
      }

      return {
        ...state,
        draftDocuments: [...newDraftFiles],
        readyToUpload: newDraftFiles.every(
          artifact => artifact.documentType && artifact.description && artifact.effectiveDate,
        ),
      }
    }

    case actionTypes.VAULTREMOVEDRAFTDOCUMENT: {
      const { id } = action.payload
      const newDraftFiles = state.draftDocuments

      const index = newDraftFiles.findIndex(e => e.id === id)
      if (index === -1) return state

      newDraftFiles.splice(index, 1)

      return {
        ...state,
        draftDocuments: [...newDraftFiles],
        readyToUpload: newDraftFiles.every(
          artifact => artifact.documentType && artifact.description && artifact.effectiveDate,
        ),
      }
    }

    case actionTypes.VAULTDRAFTDOCUMENTSRESET:
      return { ...state, draftDocuments: [], uploadingStatus: 1, readyToUpload: false }

    case actionTypes.VAULTFETCHINGDOCUMENTS:
    case actionTypes.VAULTREMOVINGDOCUMENTS:
      return { ...state, loadingDocuments: true }
    case actionTypes.VAULTFETCHINGDOCUMENTSDONE: {
      //TODO: Check once Documents are removed and what is returning from the backend.
      const { details } = action.payload
      if (details) {
        return { ...state, documents: details, loadingDocuments: false }
      } else {
        return { ...state, loadingDocuments: false }
      }
    }
    case actionTypes.VAULTREMOVINGDOCUMENTSDONE: {
      const { details } = action.payload
      return { ...state, documents: details, loadingDocuments: false }
    }

    /*NOTE: BO actions */
    case actionTypes.VAULTRESETDRAFTBO:
      return {
        ...state,
        draftBOs: [],
      }

    case actionTypes.VAULTSUBMITTINGDRAFTBOS:
      return {
        ...state,
        submittingDraftBOs: true,
      }
    case actionTypes.VAULTSUBMITTINGDRAFTBOSDONE:
      return {
        ...state,
        draftBOs: [],
        submittingDraftBOs: false,
      }
    case actionTypes.VAULTDRAFTBOADDED: {
      const newBO = { status: 'pending', id: uuidv4(), ...action.payload.BO }
      return {
        ...state,
        draftBOs: [...state.draftBOs, newBO],
      }
    }

    case actionTypes.VAULTREMOVEDRAFTBO: {
      const { id } = action.payload
      const newDraftBOs = state.draftBOs

      const index = newDraftBOs.findIndex(e => e.id === id)
      if (index === -1) return state

      newDraftBOs.splice(index, 1)

      return {
        ...state,
        draftBOs: [...newDraftBOs],
      }
    }
    case actionTypes.VAULTFETCHINGBOS:
    case actionTypes.VAULTREMOVINGBOS:
      return { ...state, loadingBOs: true }
    case actionTypes.VAULTFETCHINGBOSDONE: {
      const { details } = action.payload
      return { ...state, BOs: details, loadingBOs: false }
    }
    case actionTypes.VAULTREMOVINGBOSDONE: {
      //TODO: Check once BOs are removed and what is returning from the backend.
      const { details } = action.payload
      if (details) {
        return { ...state, documents: details, loadingBOs: false }
      } else {
        return { ...state, loadingBOs: false }
      }
    }
    //Implemented only for demo purpose
    case actionTypes.VAULTUPDATEDOCS: {
      return { ...state, documents: action.payload, loadingBOs: false }
    }
    case actionTypes.UPDATEBOS: {
      return { ...state, BOs: action.payload, loadingBOs: false }
    }
    case action.type === actionTypes.RESET_VAULT_STATE: {
      return { ...initialState }
    }
    default:
      return state
  }
}

export default reducer
